<kr-status-icon
  iconName="card-slash"
  size="large"
  data-testid="wallet_details_success_status_icon" />

<kr-wallet-card-empty
  large
  data-testid="wallet_details_success_wallet_card_empty" />

<p
  class="kr-delete-wallet-success__message"
  translate="deleteWallet.success.message"
  [translateParams]="{ name: wallet().name }"
  data-testid="wallet_details_success_message"></p>

<button
  type="button"
  fuButton
  size="m"
  uiType="primary"
  data-testid="wallet_details_success_close_button"
  (click)="closed.emit()"
  translate="deleteWallet.btn.close"></button>
